import React, { useCallback, useEffect, useState } from 'react';
import BackBar from '../components/BackBar';
import Footer from '../components/Footer';
import JobsHero from '../components/JobsHero';
import CountryChips from '../components/CountryChips';
import JobCard from '../components/JobCard';
import TrustPanel from '../components/TrustPanel';
import { fetchJobs } from '../api/jobs';
import './JobsListPage.css';

const JobsListPage = () => {
  const [q, setQ] = useState('');
  const [country, setCountry] = useState('');
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ jobs: [], total: 0, totalPages: 0 });
  const [status, setStatus] = useState('loading'); // loading | ok | error

  // Every card just links to the job's full public detail page (/jobs/:slug). Applying — including
  // an already-registered candidate's one-tap apply — starts from INSIDE that detail view now, so the
  // listing no longer needs the account/applications lookup that drove the old on-card quick-apply.

  useEffect(() => { setPage(1); }, [q, country]);
  const load = useCallback(async () => {
    setStatus('loading');
    try { setData(await fetchJobs({ q, country, page })); setStatus('ok'); }
    catch { setStatus('error'); }
  }, [q, country, page]);
  useEffect(() => { load(); }, [load]);

  return (
    <>
      <BackBar />
      <JobsHero value={q} onChange={setQ} />
      <main className="jlist-body container">
        <div className="jlist-grid">
          <div className="jlist-main">
            <CountryChips value={country} onChange={setCountry} />
            <div className="jlist-sec">
              {status === 'ok' ? `${data.total} open position${data.total === 1 ? '' : 's'}` : 'Open positions'}
            </div>

            <div className="jlist-cards">
              {status === 'loading' && [1, 2, 3, 4].map((i) => <div className="jcard-skel" key={i} />)}
              {status === 'error' && <p className="jlist-msg">Couldn’t load jobs. Please try again.</p>}
              {status === 'ok' && data.jobs.length === 0 && <p className="jlist-msg">No open positions right now. Check back soon.</p>}
              {status === 'ok' && data.jobs.map((j) => (
                <JobCard key={j.slug} job={j} />
              ))}
            </div>

            {status === 'ok' && data.totalPages > 1 && (
              <div className="jlist-pagination">
                <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>Previous</button>
                <span>Page {page} of {data.totalPages}</span>
                <button disabled={page >= data.totalPages} onClick={() => setPage((p) => p + 1)}>Next</button>
              </div>
            )}

            <div className="jlist-trust-mobile"><TrustPanel variant="strip" /></div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
export default JobsListPage;
